export enum YesNoChoice {
  No = 0,
  Yes = 1
}
